<template>
  <div class="nav" :class="`${toggleSider ? 'show-menu' : ''}`">
    <nav class="nav__container">
      <div>
        <a href="#" class="nav__link nav__logo">
          <img
            style="margin:auto; width: 35px"
            src="../../assets/img/logo/logo.png"
            alt="Web App"
          />
        </a>

        <div class="nav__list">
          <div class="nav__items">

            <router-link to="/" class="nav__link">
              <span class="material-icons nav__icon"> home </span>
              <span class="nav__name">Inicio</span>
            </router-link>

            <router-link to="/oficinas" class="nav__link"
             v-if="$auth.user.rol === 'admin' || $auth.user.rol === 'editor'"
            >
              <span class="material-icons nav__icon"> apartment </span>
              <span class="nav__name">Oficinas</span>
            </router-link>


             <router-link to="/courier" class="nav__link"
             v-if="false"
             >
              <span class="material-icons nav__icon"> local_shipping </span>
              <span class="nav__name">Courier</span>
            </router-link>



       
          <a class="nav__link c-pointer" @click="toggleModalTrackingTealca">
               <span class="material-icons nav__icon"> find_in_page </span>
               <span class="nav__name">Tracking Tealca</span>
          </a>
     

            <router-link to="/usuarios" class="nav__link"
             v-if="$auth.user.rol === 'admin'"
            >
              <span class="material-icons nav__icon"> person </span>
              <span class="nav__name">Usuarios</span>
            </router-link>


           <router-link to="/configuracion" class="nav__link"
              v-if="$auth.user.rol === 'admin' || $auth.user.rol === 'editor'"
            >
              <span class="material-icons nav__icon"> settings </span>
              <span class="nav__name">Configuracion</span>
            </router-link>




          </div>
        </div>
      </div>

    <!-- Fixed Icon Bottom -->

    <!----->
    </nav>


<ModalTrackingTealca class="animate__animated animate__fadeIn animate__faster" @toggleModal="toggleModalTrackingTealca()" v-if="modalActiveTrackingTealca" />



  </div>
</template>

<script setup>
import ModalTrackingTealca from '../modals/tracking/Tracking-Guias-Tealca.vue'

const props = defineProps({
  toggleSider: Boolean
})

import {ref} from 'vue'

const modalActiveTrackingTealca = ref(false)

const toggleModalTrackingTealca = () => {
   modalActiveTrackingTealca.value = !modalActiveTrackingTealca.value
}
</script>